module.exports = "/_next/static/videos/preview-cae7c1b1db7915f3c68a4e7b04766280.mp4";